import React from "react";
import { Filter } from "lucide-react";
import ReusableDropdown from "../../../../components/ReusableDropdown";

// Generic "match one value from a list" filter dropdown, used for the
// working-company and department (employee type) filters. Options are provided
// dynamically; an "all" entry is prepended.
const MetaFilterDropdown = ({
  theme,
  isRTL,
  language,
  label,
  allLabel,
  options = [],
  value,
  setValue,
  search,
  setSearch,
}) => {
  const items = [
    { key: "all", label: allLabel },
    ...options.map((o) => ({ key: o, label: o })),
  ];

  return (
    <div>
      <label
        style={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
          marginBottom: "8px",
          fontSize: "14px",
          fontWeight: "600",
          flexDirection: "row",
          textAlign: isRTL ? "right" : "left",
        }}
      >
        <Filter size={16} />
        {label}
      </label>
      <div style={{ position: "relative" }}>
        <ReusableDropdown
          items={items}
          value={search}
          onChange={(val) => setSearch(val)}
          onSelect={(item) => {
            setValue(item.key);
            setSearch(item.key === "all" ? "" : item.label);
          }}
          onClear={() => {
            setSearch("");
            setValue("all");
          }}
          placeholder={label}
          getItemKey={(it) => it.key}
          getItemLabel={(it) => it.label}
          theme={theme}
          language={language}
          maxItems={50}
          showAllOnArrowClick={true}
        />
      </div>
    </div>
  );
};

export default MetaFilterDropdown;
